import { API } from 'utils/globalApiServices';

export async function updateUserSettingsService({ settings, uuid }) {
  const url = `/user/${uuid}/update-settings/`;
  const { data } = await API.put(url, settings);
  return data;
}
